import { render, staticRenderFns } from "./PromotionsManagement.vue?vue&type=template&id=d1b9cf0c&scoped=true"
import script from "./PromotionsManagement.vue?vue&type=script&lang=js"
export * from "./PromotionsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b9cf0c",
  null
  
)

export default component.exports